import { makeConstantsWithKeys } from "./makeConstants";
import { createActionWithPayload } from "./createAction";
import { IActionFactory, IReduxOperations } from "src/store";
import { ICreateReduxOperation } from "./types";

const DELIMITER = `_`;

enum actionFlags {
  REQUEST = "REQUEST",
  SUCCESS = "SUCCESS",
  FAILURE = "FAILURE",
  CLEAR = "CLEAR",
}

export const createReduxOperation = (actionName: string): ICreateReduxOperation => {
  /**
   * Will generate constants map in the form of { SUCCESS: Symbol('FETCH_DATA_SUCCESS') }
   */
  const constants = makeConstantsWithKeys(
    Object.values(actionFlags).map((constant: string) => [constant, `${actionName}${DELIMITER}${constant}`])
  );

  /**
   * Generate redux actions for corresponding intents like request, success, failure
   */
  const actions: Array<IActionFactory<symbol, unknown>> = Object.values(actionFlags).map((constant) =>
    createActionWithPayload(constants.get(constant) as symbol)
  );

  const initialState: IReduxOperations = {
    pending: false,
    success: false,
    failure: false,
    errors: null,
    payload: null,
  };

  /**
   * Create a reducer to be combined with the original one in the parent context
   * @param state Redux State holding flags
   * @param action Redux Action
   */
  const reducer = (state = initialState, { type, payload = undefined }) => {
    switch (type) {
      case constants.get(actionFlags.REQUEST):
        return { ...state, pending: true, success: false };
      case constants.get(actionFlags.SUCCESS):
        return {
          ...state,
          success: true,
          pending: false,
          payload,
          failure: false,
          errors: null,
        };
      case constants.get(actionFlags.FAILURE):
        return {
          ...state,
          success: false,
          failure: true,
          pending: false,
          errors: payload,
        };
      case constants.get(actionFlags.CLEAR):
        return { ...initialState };
      default:
        return state;
    }
  };
  return {
    constants,
    actions,
    reducer,
  };
};
